import EditOrganisationDialog from "./EditOrganisationDialog"

export default EditOrganisationDialog